import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { formatBackendDateTimeEtLocale } from '../../util/dateUtil';
import { createDateTimeFromBackendDate } from '../../util/dateUtil';
import '../../style/DataTable.css';

const UpcomingMatchesBasedOnSelectedLeague = (props) => {
  const getUpcomingMatchesBasedOnSelectedLeague = () => {
    let rowData = [];
    props.futureMatches
      .sort(
        (first, second) =>
          createDateTimeFromBackendDate(first.matchDateTime) -
          createDateTimeFromBackendDate(second.matchDateTime)
      )
      .filter((match) => match.leagueId === props.leagueId)
      .slice(0, 5)
      .map((row) =>
        rowData.push({
          leagueName: row.leagueName ? row.leagueName : 'N/A',
          homeTeamName: row.homeTeamName ? row.homeTeamName : 'N/A',
          awayTeamName: row.awayTeamName ? row.awayTeamName : 'N/A',
          matchDateTime: row.matchDateTime
            ? formatBackendDateTimeEtLocale(row.matchDateTime)
            : 'N/A',
        })
      );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Liiga',
          field: 'leagueName',
        },
        {
          label: 'Koduvõistkond',
          field: 'homeTeamName',
        },
        {
          label: 'Külalisvõistkond',
          field: 'awayTeamName',
        },
        {
          label: 'Toimumise aeg',
          field: 'matchDateTime',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getUpcomingMatchesBasedOnSelectedLeague();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          className={`upcomingMatchesDataTable`}
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default UpcomingMatchesBasedOnSelectedLeague;
